import { Menu } from "../../model/menudesign/Menu";

const apiUrl = process.env.REACT_APP_API_URL;
export const PostMenus = async ( menu: Menu, page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8072/menus`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(menu)
        });
        console.log("Menu: ", menu);
        if (response.ok) {
            const jsonData = await response.json();
            console.log("JSON Data",jsonData);
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};